exports = module.exports = require("../../node_modules/@hypertype/tools/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ctx-whiteboard {\n  display: block;\n  width: 100%;\n  flex: 1;\n  position: relative;\n  background: #AAA;\n  overflow: hidden;\n}\nctx-whiteboard canvas {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n", ""]);

